import React, { useState, useEffect } from 'react';
import { ArrowUp } from 'lucide-react';
import { useContent } from '../contexts/ContentContext';

export const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isTheatreMode, isMenuOpen, is3DInspectionActive } = useContent();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Do not show button in Theatre Mode, Inspection mode, or when mobile menu is open
  if (isTheatreMode || is3DInspectionActive) return null;

  return (
    <div 
      className={`fixed bottom-8 right-8 z-[90] transition-all duration-500 transform ${
        isVisible && !isMenuOpen ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-10 opacity-0 scale-50 pointer-events-none'
      }`}
    >
      <button
        onClick={scrollToTop}
        className="w-14 h-14 bg-accent text-white rounded-full flex items-center justify-center shadow-[0_0_30px_rgba(249,115,22,0.5)] hover:bg-orange-500 hover:scale-110 active:scale-95 transition-all group"
        aria-label="Scroll to top"
      >
        <ArrowUp className="w-6 h-6 group-hover:-translate-y-1 transition-transform duration-300" />
      </button>
    </div>
  );
};